import { SIGNIN_CARD_COUNT_UPDATE, SIGNIN_CALENDAR_UPDATE, SIGNIN_SUPPLEMENT_CARD_EXCHANGE_UPDATE } from '../mutationTypes';

const initState = {
  showSupplementCardExchange: false,
  cardCount: 0,
  calendarOptions: {},
};
const getters = {};
const state = {
  ...JSON.parse(JSON.stringify(initState)),
};

const mutations = {
  [SIGNIN_CARD_COUNT_UPDATE](states, newValue = initState.cardCount) {
    const cardCount = newValue;
    Object.assign(states, { cardCount });
  },
  [SIGNIN_CALENDAR_UPDATE](states, newValue = initState.calendarOptions) {
    const calendarOptions = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { calendarOptions });
  },
  [SIGNIN_SUPPLEMENT_CARD_EXCHANGE_UPDATE](states, newValue = initState.showSupplementCardExchange) {
    const showSupplementCardExchange = JSON.parse(JSON.stringify(newValue));
    Object.assign(states, { showSupplementCardExchange });
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};
